import { getAttrMarkup, IBuildTaskDef, register } from '@wm/transpiler';
import {Attribute, Element, ParseSourceSpan, Text} from "@angular/compiler";

const noSpan = ({} as ParseSourceSpan);
const createElement = (name: string) => {
  return new Element(name, [], [], noSpan, noSpan, noSpan)
};

const addAttribute = (node: Element, name: string, value: string) => {
  const attr = new Attribute(name, value, noSpan, noSpan, noSpan, undefined, undefined);
  node.attrs.push(attr);
};
const tagName = 'div';

register('wm-prefab-container', (): IBuildTaskDef => {
  return {
    template: (node: Element)  => {
      const conditionalNode = createElement('ng-container');
      // TODO: check if compileContent is needed
      // addAttribute(conditionalNode, '*ngIf', 'compileContent');
      conditionalNode.children = conditionalNode.children.concat(node.children);
      // @ts-ignore
      conditionalNode.children.push(new Text('{{onPageContentReady()}}', null, undefined, undefined));
      node.children.length = 0;
      node.children.push(conditionalNode);
    },
    pre: attrs => `<${tagName} wmPrefabContainer ${getAttrMarkup(attrs)}>`,
    post: () => `</${tagName}>`
  };
});

export default () => {};
